"use strict";
var templateEvents = function() {
	var o = {
		months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
		_months: {
			Jan: 1,
			Feb: 2,
			Mar: 3,
			Apr: 4,
			May: 5,
			Jun: 6,
			Jul: 7,
			Aug: 8,
			Sep: 9,
			Oct: 10,
			Nov: 11,
			Dec: 12
		}
	};

	function i(t) {
		var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "x";
		if (t) {
			if (t = (t = Array.isArray(t) ? t[0] : t).toString().replace(/-/g, ""), initScript.isValidEmail(t)) return initScript.encryptEmail(t);
			var r = t.length,
				i = t.substring(Math.max(0, r - 6), r);
			return initScript.repeatStr(e, 8) + i
		}
	}

	function c(t, e) {
		for (var r = t.length, i = initScript.Array2D(r + 1, r + 1), n = initScript.Array2D(r + 1, r + 1), a = new Array(r + 1), s = new Array(r + 1), o = [], c = 1; c <= r; c++) {
			n[c][c] = e - t[c - 1];
			for (var l = c + 1; l <= r; l++) n[c][l] = n[c][l - 1] - t[l - 1] - 1
		}
		for (var u = 1; u <= r; ++u)
			for (var p = u; p <= r; ++p) n[u][p] < 0 ? i[u][p] = INF : p === r && 0 <= n[u][p] ? i[u][p] = 0 : i[u][p] = initScript.power(n[u][p], 2);
		a[0] = 0;
		for (var f = 1; f <= r; f++) {
			a[f] = INF;
			for (var h = 1; h <= f; h++) a[h - 1] !== INF && i[h][f] !== INF && a[h - 1] + i[h][f] < a[f] && (a[f] = a[h - 1] + i[h][f], s[f] = h)
		}
		return function t(e, r) {
			var i = 1 === e[r] ? 1 : t(e, e[r] - 1) + 1;
			return o.push([e[r], r]), i
		}(s, r), o
	}
	return {
		initEventListeners: function(t, e, r) {
			if (r)
				for (var i = Object.values(r), n = 0; n < i.length; ++n)
					if (i[n].events)
						for (var a = Array.isArray(i[n].events) ? i[n].events : [i[n].events], s = 0; s < a.length; ++s) {
							a[s].id && a[s].name && document.getElementById(a[s].id).addEventListener(a[s].name, resources[e][a[s].callback] ? resources[e][a[s].callback] : templateEvents[a[s].callback] ? templateEvents[a[s].callback] : initScript[a[s].callback])
						}
		},
		getSelectedOptionValue: function(t) {},
		dateFormate: function(t) {
			if (t) {
				var e, r, i = t[0].split("/"),
					n = +i[0],
					a = +i[1],
					s = +i[2];
				return (n += 11 !== (r = n) && r % 10 == 1 ? "st" : 13 !== (e = n) && e % 10 == 3 ? "rd" : "th") + " " + o.months[a - 1] + " " + s
			}
		},
		getCDNIcon: function(t, e) {
			if (t) {
				var r, i, n = t.toLowerCase().toLowerCase().replace(/[,._\W]/gm, "") + e.img_extension;
				r = e.img_src + n, (i = new Image).onload = function() {
					return !0
				}, i.onerror = function() {
					return !1
				}, i.src = r;
				return n
			}
		},
		stringMasking: i,
		truncate: function(t) {
			var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : void 0;
			if (t = Array.isArray(t) && t.length ? t[0] : t, isNaN(t)) return t;
			var r = initScript.trunc(t);
			return e ? initScript[e] ? initScript[e](r) : templateEvents[e](r) : r
		},
		dateToYearMonthFormat: function(t) {
			var e = (t = Array.isArray(t) ? t[0] : t).split("-"),
				r = o._months[e[0]];
			return +e[1] + "-" + r
		},
		maskingUtility: function(t) {
			if (t) {
				for (var e = [], r = 0; r < t.length; ++r) e.push(initScript.isValidEmail(t[r]) ? initScript.encryptEmail(t[r]) : i(t[r]));
				return e
			}
		},
		hideShowSections: function(t) {
			-1 !== t.target.href.search("table") ? (initScript.getHTMLElementByDelimiter("hideShowSection2").css("display", "block"), initScript.getHTMLElementByDelimiter("hideShowSection1").css("display", "none"), initScript.getHTMLElementByDelimiter("sortByMonthOption").css("display", "none")) : (initScript.getHTMLElementByDelimiter("hideShowSection2").css("display", "none"), initScript.getHTMLElementByDelimiter("hideShowSection1").css("display", "block"), initScript.getHTMLElementByDelimiter("sortByMonthOption").css("display", "inherit"))
		},
		bind: function(t) {
			(_self = this).elements = [], this.value = t.object[t.property], this.get = function() {
				return _self.value
			}, this.set = function(t) {
				_self.value = t;
				for (var e = 0; e < _self.elements.length; e++) {
					var r = _self.elements[e];
					r.element[r.attribute] = t
				}
			}, this.add = function(e, r, t) {
				var i = {
					element: e,
					attribute: r
				};
				return t && (e.addEventListener(t, function(t) {
					_self.get(e[r])
				}), i.event = t), this.elements.push(i), e[r] = _self.value, _self
			}, Object.defineProperty(t.object, t.property, {
				get: this.get,
				set: this.set
			}), t.object[t.property] = this.value
		},
		addMoreTextOnLargeText: function(t) {
			if(!t) return t;
			var e = initScript.strToWords(t);
			Object.assign(e, {
				pre_sum: initScript.preSum(e.words_size_ar)
			});
			var r = e.pre_sum.length;
			if (e.pre_sum[r - 1] < MAX_DESC_LEN) return t;
			for (var i = c(e.words_size_ar, e.max), n = "", a = 0, s = 0; s < 3; ++s) n += t.substr(a, e.pre_sum[i[s][1] - 1]), a = i[s][1];
			return t.substring(0, 65) + "... <a class='expandDescription' href='voidscript:void(0)' data-toggle='modal' data-target='#descriptionModal' data='" + t + "'>More</a>"
		},
		imageError: function(t) {
			return image.onerror = "", image.src = "/images/noimage.gif", !0
		},
		preventInValidNumbers: function(t) {
			-1 === (t.target.value || t.target.textContent).search(/[.]/gm) && 46 === t.which || (8 !== t.which && 0 !== t.which && t.which < 48 || 57 < t.which) && t.preventDefault()
		},
		onEmptyReturnDefault: function(t, e) {
			var r = 1 < arguments.length && void 0 !== e ? e : "Nitesh";
			return null == t || (t = Array.isArray(t) ? t[0] : t).length ? t : r
		},
		updatedOnWindowResize: function(r) {
			window.addEventListener("resize", function(t) {
				if (Array.isArray(r))
					for (var e = 0; e < r.length; ++e) r[e]();
				else r()
			})
		}
	}
}();
